export default __webpack_public_path__ + "static/media/04_COLLINES-min.105ee75a.jpg";